<section class="atw-page profile-page company-profile-page">
  <span class="shape shape-1"></span>
  <span class="shape shape-2"></span>

  <div class="atw-container">
    <div class="section-title">
      <span>
        <b>03</b>
      </span>

      <div>
        <h2>{{ isAr ? 'ملف الشركة' : 'Company Profile' }}</h2>
        <p>
          {{
            isAr
              ? 'كل بيانات الشركة المرتبطة بحسابك'
              : 'All company data linked to your account'
          }}
        </p>
      </div>
    </div>

    <div *ngIf="isLoading" class="profile-card apply-card">
      <div class="profile-loading">
        <div class="loader"></div>
        <p>{{ isAr ? 'جاري تحميل بيانات الشركة...' : 'Loading company data...' }}</p>
      </div>
    </div>

    <div *ngIf="!isLoading && errorMessage" class="error-message">
      {{ errorMessage }}
    </div>

    <div *ngIf="!isLoading && company" class="profile-card apply-card">
      <div class="profile-head">
        <div class="profile-avatar company-logo-box">
          <img
            *ngIf="logoUrl; else companyInitialTemplate"
            [src]="logoUrl"
            [alt]="companyName"
            (error)="onLogoError()"
          />

          <ng-template #companyInitialTemplate>
            <span>{{ companyInitial }}</span>
          </ng-template>
        </div>

        <div class="profile-main">
          <span class="hero-badge">
            <b>{{ isAr ? 'شركة' : 'Company' }}</b>
            {{ isAr ? 'ملف بيانات الشركة' : 'Company Data Profile' }}
          </span>

          <h1>{{ companyName }}</h1>

          <p>
            {{ isAr ? 'رقم الشركة' : 'Company ID' }}:
            <strong>{{ company.id || emptyText }}</strong>
          </p>
        </div>

        <div class="profile-actions">
          <button
            type="button"
            class="profile-edit-btn"
            *ngIf="!isEditing"
            (click)="startEditing()"
          >
            {{ isAr ? 'تعديل البيانات' : 'Edit Data' }}
          </button>
        </div>
      </div>

      <div class="success-message" *ngIf="successMessage">
        {{ successMessage }}
      </div>

      <form
        *ngIf="isEditing"
        class="profile-edit-form company-edit-form"
        [formGroup]="companyForm"
        (ngSubmit)="saveCompanyData()"
      >
        <div class="profile-form-grid">
          <div class="profile-field">
            <label>{{ isAr ? 'اسم الشركة' : 'Company Name' }}</label>
            <input type="text" formControlName="name" [class.invalid]="isInvalid('name')" />
            <small *ngIf="isInvalid('name')">
              {{ isAr ? 'اسم الشركة مطلوب' : 'Company name is required' }}
            </small>
          </div>

          <div class="profile-field">
            <label>{{ isAr ? 'اسم الشركة بالعربي' : 'Company Arabic Name' }}</label>
            <input type="text" formControlName="name_ar" [class.invalid]="isInvalid('name_ar')" />
          </div>

          <div class="profile-field">
            <label>{{ isAr ? 'التخصص' : 'Specialty' }}</label>
            <input type="text" formControlName="specialty" [class.invalid]="isInvalid('specialty')" />
          </div>

          <div class="profile-field">
            <label>{{ isAr ? 'المجال' : 'Industry' }}</label>
            <input type="text" formControlName="industry" [class.invalid]="isInvalid('industry')" />
          </div>

          <div class="profile-field">
            <label>{{ isAr ? 'الهاتف' : 'Phone' }}</label>
            <input type="text" formControlName="tel" [class.invalid]="isInvalid('tel')" />
            <small *ngIf="isInvalid('tel')">
              {{ isAr ? 'رقم الهاتف مطلوب' : 'Phone is required' }}
            </small>
          </div>

          <div class="profile-field">
            <label>{{ isAr ? 'الفاكس' : 'Fax' }}</label>
            <input type="text" formControlName="fax" [class.invalid]="isInvalid('fax')" />
          </div>

          <div class="profile-field">
            <label>{{ isAr ? 'البريد الإلكتروني' : 'Contact Email' }}</label>
            <input type="email" formControlName="contact_email" [class.invalid]="isInvalid('contact_email')" />
            <small *ngIf="isInvalid('contact_email')">
              {{ isAr ? 'البريد الإلكتروني غير صحيح' : 'Email is not valid' }}
            </small>
          </div>

          <div class="profile-field">
            <label>{{ isAr ? 'فيسبوك' : 'Facebook' }}</label>
            <input type="text" formControlName="facebook" [class.invalid]="isInvalid('facebook')" />
          </div>

          <div class="profile-field">
            <label>{{ isAr ? 'لينكدإن' : 'LinkedIn' }}</label>
            <input type="text" formControlName="linkedin" [class.invalid]="isInvalid('linkedin')" />
          </div>

          <div class="profile-field company-address-field">
            <label>{{ isAr ? 'العنوان' : 'Address' }}</label>
            <input type="text" formControlName="address" [class.invalid]="isInvalid('address')" />
          </div>
        </div>

        <div class="profile-form-actions">
          <button
            type="button"
            class="profile-cancel-btn secondary-btn"
            (click)="cancelEditing()"
            [disabled]="isSaving"
          >
            {{ isAr ? 'إلغاء' : 'Cancel' }}
          </button>

          <button type="submit" class="profile-save-btn" [disabled]="isSaving">
            {{ isSaving ? (isAr ? 'جاري الحفظ...' : 'Saving...') : (isAr ? 'حفظ التعديلات' : 'Save Changes') }}
          </button>
        </div>
      </form>

      <div class="profile-grid" *ngIf="!isEditing">
        <div
          class="profile-info-box"
          *ngFor="let item of mainInfoItems; trackBy: trackByLabel"
        >
          <span>{{ item.label }}</span>

          <strong>
            <a *ngIf="item.link && item.value; else mainValue" [href]="item.link">
              {{ displayValue(item.value) }}
            </a>

            <ng-template #mainValue>
              {{ displayValue(item.value) }}
            </ng-template>
          </strong>
        </div>
      </div>

      <div class="profile-section" *ngIf="!isEditing">
        <h3>{{ isAr ? 'الموقع' : 'Location' }}</h3>

        <div class="profile-grid">
          <div
            class="profile-info-box"
            *ngFor="let item of locationItems; trackBy: trackByLabel"
          >
            <span>{{ item.label }}</span>
            <strong>{{ displayValue(item.value) }}</strong>
          </div>
        </div>
      </div>

      <div class="profile-section" *ngIf="!isEditing">
        <h3>{{ isAr ? 'التواصل والسوشيال' : 'Contact & Social' }}</h3>

        <div class="profile-grid">
          <div
            class="profile-info-box"
            *ngFor="let item of socialItems; trackBy: trackByLabel"
          >
            <span>{{ item.label }}</span>

            <strong>
              <a
                *ngIf="item.link && item.value; else socialValue"
                [href]="item.link"
                target="_blank"
                rel="noopener"
              >
                {{ displayValue(item.value) }}
              </a>

              <ng-template #socialValue>
                {{ displayValue(item.value) }}
              </ng-template>
            </strong>
          </div>
        </div>
      </div>

      <div class="profile-section" *ngIf="!isEditing">
        <h3>{{ isAr ? 'حالة الشركة' : 'Company Status' }}</h3>

        <div class="profile-grid">
          <div
            class="profile-info-box"
            *ngFor="let item of statusItems; trackBy: trackByLabel"
          >
            <span>{{ item.label }}</span>
            <strong>{{ displayValue(item.value) }}</strong>
          </div>
        </div>
      </div>

      <div class="profile-section" *ngIf="false">
        <h3>{{ isAr ? 'بيانات إضافية' : 'Additional Data' }}</h3>

        <div class="profile-grid">
          <div
            class="profile-info-box"
            *ngFor="let item of additionalItems; trackBy: trackByLabel"
          >
            <span>{{ item.label }}</span>
            <strong>{{ displayValue(item.value) }}</strong>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
